<template>
  <div>
    <div class="row text-center full-width q-px-sm q-pt-sm">
      <div class="text-overline row items-center">
        {{ target.label }}
      </div>
    </div>
    <div
      :class="{'no-wrap': dense && tiny}"
      class="row q-pa-sm q-col-gutter-sm"
    >
      <span
        v-for="subTarget in sortedTargets"
        :key="subTarget.id"
      >
        <target-data
          ref="targets"
          :session-program="sessionProgram"
          :target="subTarget"
          :data="data"
          :active-prompt-levels="activePromptLevels"
          :dense="dense"
          :tiny="tiny"
          :disable="disable"
          :workflow-statuses="workflowStatuses"
          :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
          @record="onRecordData"
          @record-program-data="onRecordProgramData"
        />
      </span>
    </div>
  </div>
</template>
<script>
import { chain, get } from 'lodash';
import DataCollection from 'src/mixins/DataCollection';
import { defineAsyncComponent } from 'vue';

export default {

  name: 'CabBranchTarget',

  components: { TargetData: defineAsyncComponent(() => import('components/Programs/DataCollection/TargetData')) },

  mixins: [DataCollection],

  emits: ['record-target', 'record-program-data'],

  data() {
    return {
      currentTarget: null,
    };
  },

  computed: {

    sortedTargets() {
      return get(this.target, 'subTargets', []);
    }, // sortedTargets()

    nextTrial() {
      return chain(this.data)
        .get('data')
        .maxBy('trial')
        .get('trial', 0)
        .add(1)
        .value();
    }, // nextTrial()

  },

  methods: {

    finishSession() {
      return chain(this.$refs)
        .get('targets')
        .map((targetRef) => {
          if (chain(targetRef).get('finishSession').isFunction().value()) {
            return targetRef.finishSession();
          }
          return null;
        })
        .flatten()
        .compact()
        .value();
    }, // finishSession()

    onRecordData(sessionProgram, target, data) {
      // Set defaults
      const trial = this.nextTrial;

      const saveData = { ...data, trial };
      this.$emit('record-target', target, saveData);
    }, // onRecordData()

    onRecordProgramData(sessionProgram, dataObj) {
      this.$emit('record-program-data', sessionProgram, dataObj);
    },

  },
};
</script>
